$(function(){

  if($("body").hasClass("temp-collection")){
  setInterval(function () {
$(".product-grid li").each(function(){
 var main_url = $(this).find("a:first-child").attr("href");
 var result = main_url.includes("amazon");
 if(result == false){
 var myArray = main_url.split("/products/");
 var myArray2 = myArray[1].split("?");
 var hndle= myArray2[0];
 var url = $(".cols-name .all-in[handle='"+hndle+"']").html();
   if(url != ''){
 $(this).find("a").attr("href",url) 
   }
 }
});
  }, 450);
var curr_url = $("body").attr("data-col");
 $.ajax({
		url: curr_url,
		type:	'GET'
	})
	.done(function(data) {
		var productList = data;
        $("body").append(productList);
		
	})
	.fail(function(data) {})
	.always(function(data) {});
    
  } 

  
  
$(".owl-carousel-top").owlCarousel({
                center: true,
                items: 1,
                loop: false,
                margin: 0,
nav: true,
                responsive: {
                    600: {
                        items: 1,
                    },
                },
            });

            $(".owl-carousel-kitchen").owlCarousel({
                center: true,
                items: 2.9,
                loop: false,
                margin: 90,
                nav: true,
                dots: false,

                responsive: {
                   800: {
                        items: 3.98,
                      
                    },
                    600: {
                        items: 1.2,
                      
                    },
                  280: {
                        items: 1.1,
                      margin: 30,
                    },
                },
            });

  
  $('.outer_thumb').click(function(){
   $('.slide_popup').show();
  })
  $('.close_slide_popup').click(function(){
    $('.slide_popup').hide();
  })
});



$(function() {
	
	$(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();
	
	$(".accordion > .accordion-item").click(function() {
		// Cancel the siblings
		$(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
		// Toggle the item
		$(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
	});



$('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    vertical:true,
    asNavFor: '.slider-for',
    dots: false,
    focusOnSelect: true,
    verticalSwiping:true,
    responsive: [
    {
        breakpoint: 992,
        settings: {
          vertical: false,
        }
    },
    {
      breakpoint: 768,
      settings: {
        vertical: false,
      }
    },
    {
      breakpoint: 580,
      settings: {
        vertical: false,
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 380,
      settings: {
        vertical: false,
        slidesToShow: 2,
      }
    }
    ]
});
  
});